import React from 'react';
import styled from '@emotion/styled';

import { Icon } from '../../../../main/scripts/lumen';
import { Dropdown } from '../../../../main/scripts/shell';

export const SORT_OPTIONS = [
  { id: 'name-asc', label: 'Name (A-Z)' },
  { id: 'name-desc', label: 'Name (Z-A)' },
  { id: 'date-desc', label: 'Date (Most Recent)' },
  { id: 'date-asc', label: 'Date (Oldest)' }
];

export const SortDropdown = ({ value = 'name-asc', onChange }) => {
  const selected = SORT_OPTIONS.find(opt => opt.id === value);
  const label = selected ? selected.label : 'Sort by';

  return (
    <SortWrap>
      <Dropdown
        block
        trigger={
          <Trigger type="button">
            <LeftGroup>
              <Icon name="bars-sort" size={16} />
              <span>{label}</span>
            </LeftGroup>
            <Icon name="chevDown" size={16} />
          </Trigger>
        }
      >
        {SORT_OPTIONS.map(opt => (
          <Item
            type="button"
            key={opt.id}
            $selected={value === opt.id}
            onClick={() => onChange?.(opt.id)}
          >
            {opt.label}
          </Item>
        ))}
      </Dropdown>
    </SortWrap>
  );
};

const SortWrap = styled.div`
  width: 220px;
    
  > div > div:last-child {
    min-width: 100%;
  }
`;

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  height: 36px;
  padding: 7px 12px;
  border: 1px solid ${({ theme }) => theme.color.slate[500]};
  border-radius: 8px;
  background: ${({ theme }) => theme.color.bg.default};
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.color.fg.default};
  white-space: nowrap;
`;

const LeftGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const Item = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 8px 16px;
  background: ${({ $selected, theme }) =>
    $selected ? theme.color.blue[50] : 'transparent'};
  color: ${({ $selected, theme }) =>
    $selected ? theme.color.blue[800] : theme.color.fg.default};
  border: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: left;

  &:hover {
    background: ${({ $selected, theme }) =>
      $selected ? theme.color.blue[50] : theme.color.bg.subtle};
  }
`;
